<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class=" mt-0 pt-0">
        <v-row class="px-4 pt-0">
          <v-col cols="12" class="py-0">
            <h1>Task Summary</h1>
            <hr />
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="filters.email_Icontains" label="User email" />
            <v-select
              v-model="filters.closedAt_Isnull"
              :items="viewOption"
              label="View options"
              single-line
              dense
              chips
              clearable
            />
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="filters.selectedStages"
              :items="stages"
              label="Task stage"
              single-line
              dense
              chips
              multiple
            />
            <v-select
              v-model="filters.selectedTypes"
              :items="taskTypes"
              label="Task types"
              single-line
              dense
              chips
              multiple
            />
          </v-col>
          <v-col cols="4">
            <v-menu
              ref="menu1"
              v-model="menu1"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.fromDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Tasks created from"
                  prepend-icon="mdi-calendar"
                />
              </template>
              <v-date-picker v-model="filters.fromDate"></v-date-picker>
            </v-menu>
            <v-autocomplete
              v-if="staff"
              v-model="filters.assignedToId"
              class="ml-2 pt-1"
              item-text="name"
              item-value="id"
              label="Assigned to"
              clearable
              dense
              filled
              outlined
              small-chips
              solo
              rounded
              multiple
              :items="staff"
            >
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected">
                  <v-avatar left>
                    <v-img :src="data.item.avatar"></v-img>
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <img :src="data.item.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <div class="d-flex px-4">
          <v-select
            class="mr-2"
            style="max-width: 290px"
            v-model="filters.orderBy"
            :items="[
              { value: 'taskEventDate', text: 'Oldest' },
              { value: '-taskEventDate', text: 'Latest' },
            ]"
            label="Order by"
            single-line
            dense
          />
          <v-btn @click="submitSearch" :disabled="!buttonEnabled" color="primary"> Search</v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="mt-0 pt-0">
        <v-card elevation="0">
          <v-card-title v-if="taskEvents.length == 0 && search && !loading">
            No tasks match your search
          </v-card-title>
          <v-card-text>
            <div class="d-flex "></div>

            <v-simple-table>
              <thead>
                <tr>
                  <th></th>
                  <th class="text-left">Client</th>
                  <th class="text-left">Task</th>
                  <th class="text-left">Task date</th>
                  <th class="text-left">Task type</th>
                  <th class="text-left">Stage</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Assigned to</th>
                  <th class="text-left">Closed at</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(task, index) in taskList" :key="task.node.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <router-link
                      v-if="task.node.user"
                      class="black--text font-weight-bold"
                      :to="`/client-profile/${task.node.user.id}`"
                    >
                      {{ task.node.user.firstName }}
                      {{ task.node.user.lastName }}
                    </router-link>
                  </td>
                  <td>
                    <a :href="`/task/${decodeId(task.node.id)}`" target="_blank">{{ task.node.title }}</a>
                  </td>
                  <td>
                    {{ task.node.taskEventDate }}
                  </td>
                  <td>
                    {{ task.node.taskType.title }}
                  </td>
                  <td>
                    {{ task.node.stage.title }}
                  </td>
                  <td>
                    {{ task.node.description }}
                  </td>
                  <td>
                    <span v-if="task.node.assignedTo">
                      {{ task.node.assignedTo.firstName }} {{ task.node.assignedTo.lastName }}
                    </span>
                  </td>
                  <td>
                    {{ task.node.closedAt | moment("YYYY-MM-DD HH:MM") }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <scroll-loader :loader-method="loadmore" :loader-disable="!hasNextPage"> </scroll-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TASK_TYPE_QUERY, TASK_EVENT_QUERY, STAGES_QUERY } from "@/graphql/queries/task";
import { STAFF_QUERY } from "@/graphql/queries/user";
import { decodeId } from "@/lib/string";
import { getUserName } from "@/lib/username";

export default {
  name: "TaskList",
  props: {
    coachId: {
      type: [Number, String],
      required: true,
    },
    outstanding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewOption: [
        {
          text: "Show completed",
          value: false,
        },
        {
          text: "Show open",
          value: true,
        },
      ],
      taskEvents: [],
      staff: [],
      search: null,
      menu1: false,
      loading: false,
      endCursor: null,
      after: null,
      taskList: [],
      hasNextPage: null,
      buttonEnabled: true,
      filters: {
        after: null,
        selectedTypes: [],
        selectedStages: [],
        email_Icontains: "",
        assignedToId: null,
        fromDate: null,
        closedAt_Isnull: null,
        orderBy: "taskEventDate",
      },
    };
  },
  created() {
    if (this.coachId || this.outstanding) {
      this.filters.assignedToId = this.coachId ? [this.coachId] : null;
      this.filters.closedAt_Isnull = this.outstanding ? true : null;
      this.submitSearch();
    }
  },
  watch: {
    filters: {
      handler() {
        this.buttonEnabled = true;
      },
      deep: true,
    },
  },
  methods: {
    decodeId(value) {
      return decodeId(value);
    },
    submitSearch() {
      let filters = Object.fromEntries(Object.entries(this.filters));
      filters.after = null;
      this.taskList = [];
      this.search = filters;
      this.buttonEnabled = false;
    },
    loadmore() {
      this.after = this.endCursor;
    },
  },
  apollo: {
    taskEvents: {
      query: TASK_EVENT_QUERY,
      variables() {
        this.loading = true;
        let variables = {
          closedAt_Isnull: this.search.closedAt_Isnull,
          taskType_Id_In: this.search.selectedTypes,
          user_Email_Icontains: this.search.email_Icontains,
          taskEventDate_Gte: this.search.fromDate,
          after: this.search.after,
          first: 40,
          orderBy: this.search.orderBy,
        };

        if (this.search.selectedStages.length > 0) {
          variables["stage_Id_In"] = this.search.selectedStages;
        }
        if (this.search.selectedStages.length > 0) {
          variables["taskType_Id_In"] = this.search.selectedTypes;
        }

        if (this.search.assignedToId) {
          variables["assignedToId_In"] = this.search.assignedToId;
        }

        return variables;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
          this.endCursor = response.data.taskEvents.pageInfo.endCursor;
          this.hasNextPage = response.data.taskEvents.pageInfo.hasNextPage;
          this.taskList = [...this.taskList, ...response.data.taskEvents.edges];
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
      skip() {
        return !this.search;
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              id: decodeId(item.node.id),
              name: getUserName(item.node),
              avatar: item.node.userProfile?.profilePicture,
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      },
    },
    taskTypes: {
      query: TASK_TYPE_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.taskTypes.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
    stages: {
      query: STAGES_QUERY,
      update(data) {
        return data.stages.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
  },
};
</script>
